import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { CenterSpinner } from "components/CenterSpinner";

export const AuthRedirector: React.FC<{}> = () => {
  const location = useLocation();
  const navigate = useNavigate();

  console.info("Redirecting...");

  useEffect(() => {
    navigate("/auth/sign-in", { state: { landingUrl: location.pathname + location.search } });
  }, [navigate, location.pathname, location.search]);

  return <CenterSpinner size="large" />;
};
